<template>
  <AppAdsense
    ad-style="display:block"
    ad-format="autorelaxed"
    ad-client="ca-pub-9118328092882671"
    ad-slot="1345810373"
  />
</template>
